import Button from 'common/components/Button';
import Heading from 'common/components/Heading';
import Image from 'common/components/Image';
import Link from 'common/components/Link';
import Text from 'common/components/Text';
import Container from 'common/components/UI/Container';
import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import { Icon } from 'react-icons-kit';
import { ic_keyboard_arrow_right } from 'react-icons-kit/md/ic_keyboard_arrow_right';
import Fade from 'react-reveal/Fade';
import Section, {
  Content, Figure, FigureWrapper, Grid, SectionHeading
} from './technology.style';
import {FeatureGroup, FeatureItem} from '../Follow/experience.style';
import {StaticImage} from 'gatsby-plugin-image';

const WalletExperience = ({props}) => {

  return (
    <Section {...props}>
      <Container width="1400px">
        <Grid>
          <Content>
            <SectionHeading>
              <Text className="subtitle" content={"Auto Like & UnLike"} />
              <Heading content={"自動いいね・いいね解除"} />
              <Text
                  className="description"
                  content={`１日最大で1000いいねまで可能。いいね解除も自動化できます。
                  「キーワード」「ハッシュタグ」のツイートや「特定のユーザー」など、様々な条件に該当したツイートにいいねします。`}
              />
            </SectionHeading>
            <FeatureGroup style={{
              maxWidth: "460px",
              marginLeft: "auto",
              marginRight: "auto"
            }}>
              <FeatureItem key={1}>
                <figure>
                  <StaticImage
                    src={"../../../common/assets/image/lp/like-effect.png"}
                    alt="特定のアカウントやハッシュタグを自動いいねしない"
                  />
                </figure>
                <div>
                  <Heading as="h4" content={"効果がない、いいねは行わない"} />
                  <Text
                    className="description"
                    content={"いいね数が多くフォローバックが期待できないツイートに、いいねしないように制御できます。"}
                  />
                </div>
              </FeatureItem>
              <FeatureItem key={1}>
                <figure>
                  <StaticImage
                    src={"../../../common/assets/image/lp/blacklist.png"}
                    alt="特定のアカウントやハッシュタグを自動いいねしない"
                  />
                </figure>
                <div>
                  <Heading as="h4" content={"ブラックリスト機能"} />
                  <Text
                    className="description"
                    content={"特定のアカウントやハッシュタグをつけたツイートにいいねしないようにできます。"}
                  />
                </div>
              </FeatureItem>
            </FeatureGroup>
          </Content>
          <FigureWrapper>
              <Figure>
                <StaticImage
                  src={"../../../common/assets/image/lp/like-unlike.png"}
                  alt="特定のアカウントやハッシュタグを自動いいねしない"
                />
              </Figure>
          </FigureWrapper>
        </Grid>
      </Container>
    </Section>
  );
};

export default WalletExperience;
